import { render } from "./LkPage.vue?vue&type=template&id=53f89e01&scoped=true"
import script from "./LkPage.vue?vue&type=script&lang=js"
export * from "./LkPage.vue?vue&type=script&lang=js"

import "./LkPage.vue?vue&type=style&index=0&id=53f89e01&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53f89e01"]])

export default __exports__